import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogComponent } from './components/dialog/dialog.component';
import { ConfirmationDialogComponent } from './dialogs/confirmation-dialog/confirmation-dialog.component';
import {
  SuiButtonComponent,
  SuiIconComponent,
  SuiSelectInputComponent,
  SuiTextInputComponent,
} from '@stride-ui/components';
import { SheetDialogComponent } from './components/sheet-dialog/sheet-dialog.component';
import { RouterLink } from '@angular/router';
import { FullscreenDialogComponent } from './components/fullscreen-dialog/fullscreen-dialog.component';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
  imports: [
    SuiButtonComponent,
    SuiIconComponent,
    SuiSelectInputComponent,
    SuiTextInputComponent,
    OverlayModule,
    TranslateModule,
    ReactiveFormsModule,
    RouterLink,
    A11yModule,
    DialogComponent,
    ConfirmationDialogComponent,
    SheetDialogComponent,
    FullscreenDialogComponent,
  ],
  exports: [
    DialogComponent,
    SheetDialogComponent,
    ConfirmationDialogComponent,
    FullscreenDialogComponent,
  ],
})
export class DialogModule {}
